import { render } from "./AudienceComposer.vue?vue&type=template&id=f7ee6ea2"
import script from "./AudienceComposer.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceComposer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/audience/AudienceComposer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f7ee6ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f7ee6ea2', __exports__)) {
    api.reload('f7ee6ea2', __exports__)
  }
  
  module.hot.accept("./AudienceComposer.vue?vue&type=template&id=f7ee6ea2", () => {
    api.rerender('f7ee6ea2', render)
  })

}


export default __exports__